const systemSet = {
    path: 'systemSet',
    component: resolve => require(['@/pages/admin/message/systemSet.vue'], resolve)
}
export default systemSet